import _ from 'lodash';
import { Injectable } from '@angular/core';
import { MdbModalWrapperService } from 'app/core/services/mdb-modal-wrapper.service';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { ChooseImageComponent } from '../components/modals/choose-image/choose-image.component';

@Injectable({
  providedIn: 'root'
})
export class ChooseImageModalService {

  public modalRef: MdbModalRef<any> | null = null;
  public filteredImages = [];
  public searchQuery = ''

  public filteredByCategoty = []
  public images = []
  public type = ''

  constructor(
    private modalService: MdbModalWrapperService,
  ) { }

  open(data) {
    if(this.modalRef) {
      return this.modalRef;
    }

    this.modalRef = this.modalService.open(ChooseImageComponent, {
      ignoreBackdropClick: false,
      containerClass:'mdb-modal-backdrop-paybee modal fade show',
      modalClass:'modal-dialog modal-lg',
      data: {data}
    });    

    return this.modalRef;
  }

  close(data = null) {
    if (this.modalRef) {
      this.modalRef.close(data);
      this.modalRef = null;
    }
  }

  filterImages(){
    switch(this.type){
      case '':
          this.filteredImages = this.images
          this.filteredByCategoty = [...this.images]
          break;
      default:
        this.filteredImages = this.images.filter(image=>(image.usedFor.includes(this.type)))
        this.filteredByCategoty = [...this.filteredImages]
    }
    this.filteredImages = _.filter(this.filteredByCategoty, (image) => {
      return _.includes(image.metaName.toLowerCase(), this.searchQuery.toLowerCase()) ||
        _.includes(image.metaDescription.toLowerCase(), this.searchQuery.toLowerCase());
    });
  }
}
